import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { StocksSharedModule } from 'src/app/shared/components/stocks/stocks-shared.module';
import { StockRoomBatchListComponent } from './stock-room-batch-list/stock-room-batch-list.component';

// 獨立小模組：供 LayoutModule 的登入庫存警示 Dialog 重用，
// 避免把 StockRoomRoutingModule 帶進 layout (仿 StockRoomListModule 拆法)
@NgModule({
  declarations: [StockRoomBatchListComponent],
  imports: [SharedModule, StocksSharedModule],
  exports: [StockRoomBatchListComponent],
})
export class StockRoomBatchListModule { }
